<script setup>
import { ref } from 'vue'

//properties set by parent
const props = defineProps({
  fileName: {
    type: String,
    required: true,
  }
})

//reactive field proxies
const title = ref(null)
const subTitle = ref(null)
const imagePath = ref(null)
const description = ref(null)
const indicator = ref(null)

//Methods
async function getText(file) {
  let x = await fetch(file);
  let y = await x.text();
  let cardObj = JSON.parse(y);

  title.value = cardObj.title
  subTitle.value = cardObj.subTitle
  imagePath.value = import.meta.env.VITE_BASE_URL + cardObj.imagePath
  description.value = cardObj.description
  indicator.value = encodeURIComponent(cardObj.indicator)
}

//initial method run on page load
let url = import.meta.env.VITE_BASE_URL + "/json/" + props.fileName
getText(url);
//getText("json/" + props.fileName);

</script>

<template>
	<article class="card">
		<section class="card-header">
			{{title}}
		</section>
		<section class="card-image" >
			<img v-bind:src="imagePath" alt="Sample chart" width="325" height="170" />
		</section>
		<section v-if="subTitle" class="card-sub-header">
			{{subTitle}}
		</section>
		<section class="card-body">
			{{description}}
		</section>
		<router-link class="btn-primary" :to="{ name: 'ExplorerView', query: {iname: `${indicator}`}}">Get Started</router-link>	
	</article>
</template>

<style scoped>
.card {
	display: flex;
	flex-direction: column;
	min-width: 22.5rem;
	max-width: 365px;
	height: 41rem;
	padding: 1.5rem 1.25rem;
	margin-top: 1rem;
	align-items: center;
	gap: 0.625rem;

	border-radius: var(--radius-xl, 0.75rem);
	background: var(--surface-color-Default);
	box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.10);
}

.card-header {
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	line-clamp: 2;
	align-self: stretch;
	height: 4rem;

	overflow: hidden;
	color: var(--text-Header);
	font-variant-numeric: lining-nums proportional-nums;
	font-feature-settings: 'liga' off, 'clig' off;
	text-overflow: ellipsis;

	/* Regular/H5 */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-H5, 1.5625rem);
	font-style: normal;
	font-weight: 400;
	line-height: var(--font-line-height-H5, 2rem); /* 128% */
}

.card-image {
	height: 10.648rem;
	align-self: stretch;
	aspect-ratio: 325.00/170.37;

	/* background: url(<path-to-image>) lightgray -32.614px -59.754px / 119.228% 208.3% no-repeat; */
}

.card-sub-header {
	align-self: stretch;
	height: 1.75rem;

	overflow: hidden;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 1;
	line-clamp: 1;
	align-self: stretch;	

	color: var(--text-Link);
	font-variant-numeric: lining-nums proportional-nums;
	font-feature-settings: 'liga' off, 'clig' off;

	/* Medium/H6 */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-H6, 1.25rem);
	font-style: normal;
	font-weight: 500;
	line-height: var(--font-line-height-H6, 1.75rem); /* 140% */

}

.card-body {
	color: var(--text-Secondary);
	font-variant-numeric: lining-nums proportional-nums;
	font-feature-settings: 'liga' off, 'clig' off;
	text-overflow: ellipsis;

	/* Regular/Base */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base, 1rem);
	font-style: normal;
	font-weight: 400;
	line-height: var(--font-line-height-Base, 1.5rem); /* 150% */

	height: 18rem;
	width: 20.3125rem;	

	/*overflow: hidden;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 10;
	line-clamp: 10;
	align-self: stretch;*/
}

.btn-primary {
	padding: 0.75rem 0.5rem;
	align-self: stretch;
	text-align: center;
	border-radius: .5rem;
	text-decoration: none;
}

/* .card-submit {
	display: flex;
	height: 3rem;
	min-height: 2.5rem;
	padding: 0.75rem 0.5rem;
	justify-content: center;
	align-items: center;
	gap: 0.625rem;
	align-self: stretch;

	border-radius: 0.5rem;
	border: 1px solid var(--button-color-primary-Default, #064291);
	background: var(--button-color-primary-Default, #064291);
	color: var(--text-Inverse, #FFF);
} */

</style>